import React, { useState, useEffect, useRef } from 'react'
import { SvgIcon as MuiSvgIcon } from '@mui/material';
import {
  EventNoteOutlined,
  ChildCareOutlined,
  AccessibleOutlined,
  AllInclusiveOutlined,
  QueueOutlined,
  LoyaltyOutlined
} from '@mui/icons-material';

const iconMap = {
  'note': EventNoteOutlined,
  'child-care': ChildCareOutlined,
  'accessible': AccessibleOutlined,
  'all-inclusive': AllInclusiveOutlined,
  'queue': QueueOutlined,
  'loyalty': LoyaltyOutlined,
}

export default function SvgIcon(props) {
  const { iconName, ...svgProps } = props;
  const IconRef = useRef(iconMap[iconName]);
  const [svgContent, setSvgContent] = useState(null);

  useEffect(() => {
    if (IconRef.current) {
      setSvgContent(null); // Reset if it's an MUI icon
      return;
    }

    const importIcon = async () => {
      try {
        const module = await import(`../../../icons/${iconName}.svg`);
        const response = await fetch(module.default);
        const svgText = await response.text();
        setSvgContent(svgText);
      } catch (err) {
        console.error(`Icon "${iconName}" not found.`);
      }
    };

    importIcon();
  }, [iconName]);

  // If it's a Material UI icon, render it using MuiSvgIcon
  if (IconRef.current) {
    const Icon = IconRef.current;
    return <MuiSvgIcon component={Icon} {...svgProps} />;
  }

  // Render inline SVG
  if (svgContent) {
    return ({
      // d-inline-flex - keeps span inline and enables flex layout
      ...(svgProps.viewBox ? <svg {...svgProps} dangerouslySetInnerHTML={{ __html: svgContent }} /> : <span className='d-inline-flex' {...svgProps} dangerouslySetInnerHTML={{ __html: svgContent }} />)
    });
  }

  return null;
}
